import { Type } from '@angular/core';
import { IconType } from 'components/layout/icon/icon.component';
import { CredentialType } from 'enums/CredentialType';

export class MenuItem {
	public icon: IconType | undefined;
	public title: string = '';
	public text: string = '';
	public component?: Type<Object>;
	public action: any;
	public credentials?: CredentialType[];
	public disabled = false;

	public constructor(init?: Partial<MenuItem>) {
		Object.assign(this, init);
	}
}

export enum MenuLayout {
	AlwaysVisible = 0,
	VisibleOnHover = 1,
	AlwaysVisibleWithMenu = 2,
	VisibleOnHoverWithMenu = 3,
}
